// Canonical display label for Customer.customerType / service-type values — always
// "CableTV" (never "catv", "CableTV", "CATV", or a bare capitalize()'d "Catv") per
// company style. Internal values (customerType: 'catv', paymentFor: 'catv_renewal',
// CSS classes like badge-catv) are untouched — this only governs what's shown on screen.
export function customerTypeLabel(type) {
  if (type === 'catv') return 'CableTV';
  if (type === 'broadband') return 'Broadband';
  if (type === 'both') return 'Combo';
  return type || '—';
}
